import {
  asyncDefaults,
  makeAsyncReducer,
  makeAsyncResetReducer,
  mergeReducers
} from '../../../ui-lottery/src/utils/async_utils';
import * as types from '../constants/actions';

const fetchEvents = makeAsyncReducer(types.FETCH_EVENTS);

const resetEvents = makeAsyncResetReducer(types.RESET_EVENTS, []);

export default mergeReducers(asyncDefaults([]), types.PREFIX, fetchEvents, resetEvents);

export const getEvents = (state) => state.portal.events.data;
